import { GetRegion } from 'constants.js';
import { store } from '../store.js';
import Utils from './Utils';
export const getEncodesByKey = isLive => {
  const encodes = store.getState()?.metadata?.supported_stream;
  const encodesParse = encodes ? JSON.parse(encodes) : '';
  const encodesByregion = encodesParse?.[GetRegion()] || encodesParse?.default;
  const deviceSO = Utils.getDeviceOS();
  const encodesByBrowser =
    encodesByregion?.[deviceSO] || encodesByregion?.default;
  const encodesByLiveOrVod = encodesByBrowser?.[(isLive ? 'live' : 'vod')];

  return encodesByLiveOrVod;
};
